import { i18n } from '@localization'
import { useRoute } from '@react-navigation/native'
import { FlashList } from '@shopify/flash-list'
import { useBrandDetailsById } from '@zet/feature-brands/api/brands/hooks'

import { EligibilityCard } from '@components/eligibilityCard'

export const EligibilityCriteria = () => {
  const { params } = useRoute()
  const brandId = params?.brandId
  const { data: content } = useBrandDetailsById(brandId || '')
  const salaried = content?.eligibilityCriteria?.salaried
  const selfEmployed = content?.eligibilityCriteria?.selfEmployed

  const data = [
    {
      id: 'index-1',
      type: 'salaried',
      ageGroup: salaried?.ageGroup,
      incomeRange: salaried?.incomeRange,
      documentsRequired: [
        {
          heading: i18n.t('eligibilityCriteria.identityProof'),
          content: salaried?.documentsRequired?.identityProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.addressProof'),
          content: salaried?.documentsRequired?.addressProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.incomeProof'),
          content: salaried?.documentsRequired?.incomeProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.other'),
          content: salaried?.documentsRequired?.Other,
        },
      ],
    },
    {
      id: 'index-2',
      type: 'selfEmployed',
      ageGroup: selfEmployed?.ageGroup,
      incomeRange: selfEmployed?.incomeRange,
      documentsRequired: [
        {
          heading: i18n.t('eligibilityCriteria.identityProof'),
          content: selfEmployed?.documentsRequired?.identityProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.addressProof'),
          content: selfEmployed?.documentsRequired?.addressProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.incomeProof'),
          content: selfEmployed?.documentsRequired?.incomeProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.other'),
          content: selfEmployed?.documentsRequired?.Other,
        },
      ],
    },
  ]

  return (
    <FlashList
      showsVerticalScrollIndicator={false}
      data={data}
      estimatedItemSize={5}
      renderItem={({ item }) => EligibilityCard(item)}
      keyExtractor={(item) => item.id}
    />
  )
}
